export default __webpack_public_path__ + "static/media/nachos.033f95f1.png";